/**
 * Layout commun pour les pages de génération IA
 * Design épuré aligné avec AIDashboard
 */

import { Button, Layer, Stack } from '@carbon/react'
import type { CarbonIconType } from '@carbon/icons-react'
import { ArrowLeft } from '@carbon/icons-react'
import styles from './AiGeneratorPageLayout.module.scss'

export interface AiGeneratorPageLayoutProps {
  icon: CarbonIconType
  title: string
  description: string
  features?: {
    icon: React.ReactNode
    title: string
    description: string
  }[]
  children: React.ReactNode
  className?: string
}

export function AiGeneratorPageLayout({
  icon: Icon,
  title,
  description,
  children,
  className = '',
}: AiGeneratorPageLayoutProps) {
  return (
    <div className={`${styles.page} ${className}`}>
      <div className={styles.wrapper}>
        {/* Retour */}
        <Button
          kind="ghost"
          size="sm"
          renderIcon={ArrowLeft}
          onClick={() => window.history.back()}
          className={styles.backButton}
        >
          Retour
        </Button>

        {/* Header compact */}
        <Layer className={styles.header}>
          <div className={styles.headerContent}>
            <div className={styles.headerIcon}>
              <Icon size={24} />
            </div>
            <div>
              <h1 className={styles.title}>{title}</h1>
              <p className={styles.description}>{description}</p>
            </div>
          </div>
        </Layer>

        {/* Contenu principal */}
        <Stack gap={5} className={styles.content}>
          {children}
        </Stack>
      </div>
    </div>
  )
}
